import * as yup from 'yup'
import {
  validationSchema as purposeValidationSchema,
  fieldNames as purposeFieldNames,
} from '../PurposeModal/data'
import {
  validationSchema as programStartDateValidationSchema,
  fieldNames as programStartDateFieldNames,
} from '../ProgramStartDateModal/data'
import {
  validationSchema as goalsValidationSchema,
  fieldNames as goalsFieldNames,
} from '../GoalsModal/data'
import {
  validationSchema as implementationApproachValidationSchema,
  fieldNames as implementationApproachFieldNames,
} from '../ImplementationApproachModal/data'

export const validationSchemas = [
  yup.object().shape({}),
  implementationApproachValidationSchema,
  purposeValidationSchema,
  goalsValidationSchema,
  programStartDateValidationSchema,
]

export const validationSchema = implementationApproachValidationSchema
  .concat(goalsValidationSchema)
  .concat(purposeValidationSchema)
  .concat(programStartDateValidationSchema)

export const fieldNameSets = [
  [],
  implementationApproachFieldNames,
  purposeFieldNames,
  goalsFieldNames,
  programStartDateFieldNames,
]
